import {
  FETCH_VM_TEMPLATE,
  RESET_VM_TEMPLATE,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const vmTemplateView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_TEMPLATE:
      return { data: action.payload, others: action.others };
    case RESET_VM_TEMPLATE:
      return initialState;
    default:
      return state;
  }
};

export default vmTemplateView;
